import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col, Alert } from 'reactstrap';
import SimpleBar from 'simplebar-react';

import { ReactComponent as BellIcon } from '../../../assets/images/notifications.svg';

import './NotificationDropdown.scss';

function timeSince(date) {
	var seconds = Math.floor((new Date() - date) / 1000);

	var interval = seconds / 31536000;

	if (interval > 1) {
		return Math.floor(interval) + ' anni fa';
	}
	interval = seconds / 2592000;
	if (interval > 1) {
		return Math.floor(interval) + ' mesi fa';
	}
	interval = seconds / 86400;
	if (interval > 1) {
		return Math.floor(interval) + ' giorni fa';
	}
	interval = seconds / 3600;
	if (interval > 1) {
		return Math.floor(interval) + ' ore fa';
	}
	interval = seconds / 60;
	if (interval > 1) {
		return Math.floor(interval) + ' minuti fa';
	}
	return 'adesso'; //Math.floor(seconds) + ' seconds ago';
}

const NotificationDropdown = (props) => {
	const [show, setShow] = useState(false);

	async function handleOnNotificationClick(notificationId, notificationLink) {
		//TODO move this to saga
		let userId = JSON.parse(localStorage.getItem('authUser'))._id;
		// await setReadNotification(userId, notificationId);
		props.loadUserNotifications();
		props.history.push(notificationLink);
	}

	function handleOnShowAllClick() {
		if (props.history.location.pathname === '/notifications')
			props.history.go('/notifications');
	}

	const nUnread = props.notifications.filter((n) => n.read === false).length;
	return (
		<>
			<Dropdown
				isOpen={show}
				toggle={() => {
					//setShow(!show)
				}}
				className="dropdown d-inline-block"
				tag="li">
				<DropdownToggle
					className="btn noti-icon waves-effect"
					tag="a"
					href="/notifications"
					id="page-header-notifications-dropdown">
					<BellIcon />
					{nUnread > 0 && (
						<span className="badge badge-danger badge-pill">{nUnread}</span>
					)}
				</DropdownToggle>

				<DropdownMenu className="dropdown-menu dropdown-menu-lg p-0" right>
					<div className="p-3">
						<Row className="align-items-center">
							<Col>
								<h6 className="m-0">Notifiche</h6>
							</Col>
							<div className="col-auto">
								<Link to="/notifications-list" className="small" onClick={handleOnShowAllClick}>
									Vedi tutte
								</Link>
							</div>
						</Row>
					</div>

					<SimpleBar style={{ maxHeight: '230px' }}>
						{/* <Link to="" className="text-reset notification-item">
							<div className="media">
								<div className="avatar-xs mr-3">
									<span className="avatar-title bg-primary rounded-circle font-size-16">
										<i className="bx bx-cart"></i>
									</span>
								</div>
								<div className="media-body">
									<h6 className="mt-0 mb-1">{props.t('Your order is placed')}</h6>
									<div className="font-size-12 text-muted">
										<p className="mb-1">
											{props.t('If several languages coalesce the grammar')}
										</p>
										<p className="mb-0">
											<i className="mdi mdi-clock-outline"></i> {props.t('3 min ago')}{' '}
										</p>
									</div>
								</div>
							</div>
						</Link> */}
						{
							// props.loading ? (
							// 	<Loader />
							// ) : 
							props.error ? (
								<Alert className="mb-0" color="danger">
									{props.error}
								</Alert>
							) : props.notifications && props.notifications.length > 0 ? (
								props.notifications.map((n) => {
									let createdAt = new Date(n.createdAt);

									let imageText = '';
									if (n.title && n.title.split(' ')) {
										imageText += n.title.split(' ')[0]
											? n.title.split(' ')[0].charAt(0)
											: '';
										imageText +=
											' ' + n.title.split(' ')[1]
												? n.title.split(' ')[1].charAt(0)
												: '';
									}

									return (
										<Link
											to='#'
											className="text-reset notification-item"
											key={'n-' + n._id}
											onClick={() => handleOnNotificationClick(n._id, n.link)}>
											<div className="media">
												{n.image ? (
													<img
														src={n.image}
														className="mr-3 rounded-circle avatar-xs"
														alt="user-pic"
													/>
												) : (
													<div className="avatar-xs mr-3">
														<span className="avatar-title rounded-circle">
															{imageText}
														</span>
													</div>
												)}
												<div className="media-body">
													<h6 className="mt-0 mb-1">{n.title}</h6>
													<div className="font-size-12 text-muted">
														<p className="mb-1">{n.message}</p>
														<p className="mb-0">
															<i className="mdi mdi-clock-outline mr-1"></i>
															{timeSince(createdAt)}
														</p>
													</div>
												</div>
											</div>
										</Link>
									);
								})
							) : (
								<p className="text-center">Nessuna nuova notifica.</p>
							)}
					</SimpleBar>
					<div className="p-2 border-top">
						<Link
							className="btn btn-sm btn-link font-size-14 btn-block text-center"
							to="/notifications-list" onClick={handleOnShowAllClick}>
							Vedi tutte
						</Link>
					</div>
				</DropdownMenu>
			</Dropdown>
		</>
	);
};

function mapStateToProps(state) {
	return {
		notifications: [
			{
				image: {
					url: ''
				},
				title: '',
				message: ''
			}
		],
		// loading: state.User.notificationsLoading
	};
}

export default connect(mapStateToProps, null)(withRouter(NotificationDropdown));
